import hooks from './shipment-quotes.hooks';
import createSchema from './shipment-quotes.schema';

export default (app) => {
  const service = app.service('api/shipment-quotes');
  const schemas = createSchema(app);
  service.timeout = 1000 * 60;
  service.schema = schemas.schema;
  service.acceptSchema = schemas.acceptSchema;
  service.hooks(hooks);

  service.accept = function (id, shipmentData) {
    return app.service(`api/shipment-quotes/${id}/accept`).create(shipmentData);
  };
};
